<template>
  <div v-editable="blok" class="blok-html">
    <div v-html="code"></div>
  </div>
</template>

<script>
export default {
  name: 'blok-html',
  props: ['blok'],
  computed: {
    code() {
      return this.blok.code
    },
  },
}
</script>

<style lang="scss" scoped>
.blok-html {
  padding: 20px;
  & ::v-deep iframe {
    max-width: 100%;
  }
}
</style>
